"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Lazy = void 0;
var runtype_1 = require("../runtype");
/**
 * Construct a possibly-recursive Runtype.
 */
function Lazy(delayed) {
    var data = {
        get tag() {
            return getWrapped()['tag'];
        },
    };
    var cached;
    function getWrapped() {
        if (!cached) {
            cached = delayed();
            for (var k in cached)
                if (k !== 'tag')
                    data[k] = cached[k];
        }
        return cached;
    }
    return (0, runtype_1.create)(function (x) {
        return getWrapped().validate(x);
    }, data);
}
exports.Lazy = Lazy;



// WEBPACK FOOTER //
// /static/node_modules/runtypes/lib/types/lazy.js